window.global ||= window; // Vite doesn't create the global object like webpack does, so polyfill here

import 'core-js/stable'
import { createApp, nextTick } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import * as nativeBridge from '@/native-bridge'
import {PMCurrencyFilters, PMDateFilters, PMBus, PMAPI, PMPermissions, PMConstants, IDHasher} from '@/plugins'
import PortalVue from 'portal-vue'
import PrimeVue from 'primevue/config'

import MoreInfo from '@/components/MoreInfo'
import CollapseToggleButton from '@/components/CollapseToggleButton'
import AlertBox from '@/components/AlertBox'
import FormInput from '@/components/FormInput'
import FormErrors from '@/components/FormErrors'
import PageSearch from '@/components/PageSearch'

import 'jquery'
import 'popper.js'
import 'bootstrap/dist/js/bootstrap.js'
import 'muicss/dist/js/mui.min.js'
import 'toastr/toastr.scss'
import 'select2/dist/css/select2.min.css'

import '@/polyfills/endsWith'

import '@/assets/fonts/roboto/roboto.css'
import '@/assets/font-awesome/css/all.css'

import '@/assets/scss/style.scss'
import '@/assets/scss/local.scss'

import * as Sentry from "@sentry/vue";
import { buildSentryOptions } from '@/sentry'

const app = createApp(App)

const sentryOptions = buildSentryOptions(import.meta.env, { app, router })
if (sentryOptions) {
    Sentry.init(sentryOptions)
}

app.config.globalProperties.$nextTick = nextTick
app.use(router)
app.use(store)

app.use(PMDateFilters)
app.use(PMCurrencyFilters)
app.use(PMAPI)
app.use(PMBus)
app.use(PMPermissions)
app.use(PMConstants)
app.use(PortalVue)
app.use(IDHasher)
app.use(PrimeVue)

app.component('MoreInfo', MoreInfo)
app.component('CollapseToggleButton', CollapseToggleButton)
app.component('AlertBox', AlertBox)
app.component('FormInput', FormInput)
app.component('FormErrors', FormErrors)
app.component('PageSearch', PageSearch)

app.mount('#app-container')

// Tell a modern native host we are up; it replies with hostInfo (see native-bridge.js).
// A no-op in a browser and in the legacy Cordova shell.
//
// Waits on isReady(): app.mount() returns before the initial navigation resolves,
// so currentRoute is still the router's START_LOCATION ('/') at that point and a
// deep link would be announced as '/'. A failed first navigation still announces.
router.isReady()
    .catch(() => {})  // a failed first navigation still means the app is up
    .then(() => nativeBridge.announceReady(router.currentRoute.value?.path ?? '/'))
    .catch(() => {})  // a host throwing from postMessage is not worth reporting

// Mixpanel
import mixpanel from 'mixpanel-browser'
if (import.meta.env.VITE_MIXPANEL_ENABLED && import.meta.env.VITE_MIXPANEL_PROJECT_TOKEN) {
    try {
        mixpanel.init(import.meta.env.VITE_MIXPANEL_PROJECT_TOKEN, {debug: false})
    }
    catch (ex) {
        Sentry.captureException(ex)
    }
}
